<template>
  <div id="rateMain">
    <el-row>
      <el-col :span="24"
              class="titleLine">
        <el-breadcrumb separator-class="el-icon-arrow-right"
                       class="titleLine1">
          <el-breadcrumb-item>费率</el-breadcrumb-item>
          <el-breadcrumb-item>费率设置</el-breadcrumb-item>
          <el-breadcrumb-item>费率列表</el-breadcrumb-item>
          <el-breadcrumb-item>{{navigationMap[rateActiveName]}}</el-breadcrumb-item>
        </el-breadcrumb>
      </el-col>
    </el-row>
    <el-row>
      <el-form :inline="true"
               class="demo-form-inline">
        <el-form-item label="客户名称::"
                      style="margin-bottom: 10px;">
          <el-select v-model="selCustID"
                     filterable
                     clearable
                     placeholder="请选择客户"
                     @change="changeValue">
            <el-option v-for="item in choiceCusts"
                       :key="item.fCustID"
                       :label="item.unionName"
                       :value="item.fCustID">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="费率名称::">
          <el-input placeholder="请输入费率名称"
                    v-model="bindQueryInput"
                    class="input-with-select">
            <!--<el-button slot="append" icon="el-icon-search" @click="bindQuery"></el-button>-->
          </el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary"
                     icon="el-icon-search"
                     size="small"
                     @click="bindQuery">查询</el-button>
        </el-form-item>
        <el-form-item style="float:right;margin-right:0px">
          <el-button type="primary"
                     size="small"
                     v-if="is_edit"
                     @click="addSyncRate">新增费率</el-button>
          <el-button type="primary"
                     size="small"
                     @click="syncAllRate"
                     v-if="is_syn">批量下发</el-button>
        </el-form-item>
      </el-form>
    </el-row>
    <el-row>
      <el-tabs v-model="rateActiveName"
               type="card"
               @tab-click="tabClick">
        <el-tab-pane label="费率列表"
                     name="rateList">
          <el-row>
            <el-table :data="rateList"
                      border
                      v-loading="loading"
                      highlight-current-row
                      style="width: 100%"
                      :height="tableHeight"
                      ref="singleTable"
                      @current-change="rateCurrentChange">
              <el-table-column type="index"
                               width="50"
                               :index="indexMethod"
                               label="序号">
              </el-table-column>
              <el-table-column prop="fOpLastTimeName"
                               width="180"
                               label="最后同步时间">
              </el-table-column>
              <el-table-column prop="fCustNo"
                               width="80"
                               label="客户编号">
              </el-table-column>
              <el-table-column prop="fCustName"
                               width="160"
                               label="客户名称">
              </el-table-column>
              <el-table-column prop="fRateName"
                               width="300"
                               label="费率名称">
              </el-table-column>
              <el-table-column prop="rateTemplate"
                               width="100"
                               label="费率模板">
              </el-table-column>
              <el-table-column prop="holidayName"
                               width="100"
                               label="费率类型">
              </el-table-column>
              <el-table-column prop="fRemark"
                               label="费率说明">
              </el-table-column>
              <el-table-column fixed="right"
                               label="操作"
                               align="left"
                               width="300">
                <template slot-scope="scope">
                  <el-button @click="viewRate(scope.row)"
                             type="success"
                             size="mini">查看</el-button>
                  <el-button size="mini"
                             type="warning"
                             v-if="is_edit"
                             @click="editRateClient(scope.$index, scope.row)">编辑</el-button>
                  <el-button size="mini"
                             type="danger"
                             v-if="is_del"
                             @click="deleteRateClient(scope.$index, scope.row)">删除</el-button>
                  <el-button size="mini"
                             type="info"
                             v-if="is_syn&& scope.row.fCustTypeID=='0'"
                             @click="synRate(scope.$index, scope.row,false)">上传</el-button>
                </template>
              </el-table-column>
            </el-table>
          </el-row>
        </el-tab-pane>
        <el-tab-pane label="待同步"
                     name="synRateList">
          <el-row>
            <el-table :data="synRateList"
                      border
                      highlight-current-row
                      :row-class-name="tableRowClassName"
                      style="width: 100%"
                      :height="tableHeight"
                      v-loading="loading"
                      ref="singleTable"
                      @current-change="rateCurrentChange">
              <el-table-column type="index"
                               width="50"
                               :index="indexMethod"
                               label="序号">
              </el-table-column>
              <el-table-column prop="fCustNo"
                               width="80"
                               label="客户编号">
              </el-table-column>
              <el-table-column prop="fCustName"
                               width="160"
                               label="客户名称">
              </el-table-column>
              <el-table-column prop="fRateName"
                               width="300"
                               label="费率名称">
              </el-table-column>
              <el-table-column prop="rateTemplate"
                               width="100"
                               label="费率模板">
              </el-table-column>
              <el-table-column prop="holidayName"
                               width="100"
                               label="费率类型">
              </el-table-column>
              <el-table-column prop="fRemark"
                               label="费率说明">
              </el-table-column>
              <el-table-column prop="fSyncRemark"
                               label="同步说明">
              </el-table-column>
              <el-table-column fixed="right"
                               label="操作"
                               align="center"
                               width="300">
                <template slot-scope="scope">
                  <el-button @click="viewRate(scope.row)"
                             type="success"
                             size="mini">查看</el-button>
                  <el-button size="mini"
                             type="warning"
                             v-if="is_edit"
                             @click="editRateClient(scope.$index, scope.row)">编辑</el-button>
                  <el-button size="mini"
                             type="danger"
                             v-if="is_del"
                             @click="deleteRateClient(scope.$index, scope.row)">删除</el-button>
                  <el-button size="mini"
                             type="info"
                             v-if="is_syn"
                             @click="synRate(scope.$index, scope.row,true)">下发</el-button>
                </template>
              </el-table-column>
            </el-table>
          </el-row>
        </el-tab-pane>
      </el-tabs>
    </el-row>
    <el-row class="pagination">
      <el-col :span="24">
        <div class="block">
          <span class="demonstration"></span>
          <el-pagination background
                         @size-change="handleSizeChange"
                         :current-page.sync="pageNo"
                         @current-change="handlePage"
                         :page-size="pageSize"
                         :page-sizes="[10, 20, 50, 100]"
                         layout="total,sizes, prev, pager, next, jumper"
                         :total="total"
                         v-if="total>0">
          </el-pagination>
        </div>
      </el-col>
    </el-row>
    <div class="rateEditOrDetailDiv">
      <el-dialog :title="detailTitle"
                 width="60%"
                 v-dialogDrag
                 :visible.sync="rateEditOrDetail"
                 top="7vh"
                 left="0vh">
        <el-card class="box-card">
          <el-form :model="curRowInfo">
            <el-row class="form-row">
              <el-col :span="4"
                      class="el-form-item__label myParkLableClass text-red">客户名称::</el-col>
              <el-col :span="7">
                <el-select v-model="curRowInfo.fCustID"
                           filterable
                           placeholder="请选择客户"
                           :disabled="!curRowInfo.isEdit||curRowInfo.op=='edit'"
                           style="width: 100%">
                  <el-option v-for="item in choiceCusts"
                             :key="item.fCustID"
                             :label="item.unionName"
                             :value="item.fCustID">
                  </el-option>
                </el-select>
              </el-col>
              <el-col :span="4"
                      class="el-form-item__label rateLable text-red">费率名称::</el-col>
              <el-col :span="7">
                <el-input v-model="curRowInfo.fRateName"
                          :disabled="!curRowInfo.isEdit"
                          class="rateInput"></el-input>
              </el-col>
            </el-row>
            <el-row class="form-row">
              <el-col :span="4"
                      class="el-form-item__label rateLable text-red">费率模板::</el-col>
              <el-col :span="7">
                <el-select v-model="curRowInfo.fTemplateID"
                           :disabled="!curRowInfo.isEdit||curRowInfo.op=='edit'"
                           style="width: 100%">
                  <el-option v-for="item in rateTemplate"
                             :key="item.value"
                             :label="item.text"
                             :value="item.value">
                  </el-option>
                </el-select>
              </el-col>
              <el-col :span="4"
                      class="el-form-item__label rateLable text-red">费率类型::</el-col>
              <el-col :span="7">
                <el-select v-model="curRowInfo.fIsHoliday"
                           :disabled="!curRowInfo.isEdit||curRowInfo.op=='edit'"
                           style="width: 100%">
                  <el-option v-for="item in rateType"
                             :key="item.value"
                             :label="item.text"
                             :value="item.value">
                  </el-option>
                </el-select>
              </el-col>
            </el-row>
            <el-row class="form-row">
              <el-col :span="4"
                      class="el-form-item__label myChnlLableClass text-red">备注信息::</el-col>
              <el-col :span="19">
                <el-input type="textarea"
                          v-model="curRowInfo.fRemark"
                          :disabled="!curRowInfo.isEdit"></el-input>
              </el-col>
            </el-row>
            <el-row class="form-row">
                <el-col :span="12"
                    style="color:red;margin-top:6px;margin-left:6px;">费率如果有修改一定要重启门岗软件和插件</el-col>
              </el-row>
          </el-form>
        </el-card>
        <div id="template1"
             v-if="curRowInfo.fTemplateID === '1'"
             style="padding-top: 5px;">
          <fieldset>
            <legend>标准费率一</legend>
            <el-form>
              <el-row class="form-row">
                <el-col :span="5"
                        class="el-form-item__label rateLable">时间段::</el-col>
                <el-col :span="3">
                  <el-select v-model="rateParamInfoObject.startTime001"
                             filterable
                             :disabled="true"
                             class="rateInput">
                    <el-option v-for="item in time"
                               :key="item.value"
                               :label="item.text"
                               :value="item.value">
                    </el-option>
                  </el-select>
                </el-col>
                <el-col :span="2"
                        style="line-height: 30px;"
                        align="center">至</el-col>
                <el-col :span="3">
                  <el-select v-model="rateParamInfoObject.endTime001"
                             filterable
                             :disabled="true"
                             class="rateInput">
                    <el-option v-for="item in time"
                               :key="item.value"
                               :label="item.text"
                               :value="item.value">
                    </el-option>
                  </el-select>
                </el-col>
                <el-col :span="6"
                        class="el-form-item__label rateLable">免费停车时间（分钟）::</el-col>
                <el-col :span="5">
                  <el-input v-model="rateParamInfoObject.txtFreeTime001"
                            :disabled="!curRowInfo.isEdit"
                            class="rateInput"></el-input>
                </el-col>
              </el-row>
              <el-row class="form-row">
                <el-col :span="8"
                        class="el-form-item__label rateLable text-red">标准停车计费时间（分钟）::</el-col>
                <el-col :span="5">
                  <el-input v-model="rateParamInfoObject.txtCalcTime001"
                            :disabled="!curRowInfo.isEdit"
                            class="rateInput"></el-input>
                </el-col>
                <el-col :span="6"
                        class="el-form-item__label rateLable text-red">标准停车计费金额（元）::</el-col>
                <el-col :span="5">
                  <el-input v-model="rateParamInfoObject.txtCalcAmt001"
                            :disabled="!curRowInfo.isEdit"
                            class="rateInput"></el-input>
                </el-col>
              </el-row>
              <el-row class="form-row">
                <el-col :span="8"
                        class="el-form-item__label rateLable">标准停车计费时间二（分钟）::</el-col>
                <el-col :span="5">
                  <el-input v-model="rateParamInfoObject.txtCalcTime002"
                            :disabled="!curRowInfo.isEdit"
                            class="rateInput"></el-input>
                </el-col>
                <el-col :span="6"
                        class="el-form-item__label rateLable">标准停车计费金额二（元）::</el-col>
                <el-col :span="5">
                  <el-input v-model="rateParamInfoObject.txtCalcAmt002"
                            :disabled="!curRowInfo.isEdit"
                            class="rateInput"></el-input>
                </el-col>
              </el-row>
              <el-row class="form-row">
                <el-col :span="8"
                        class="el-form-item__label rateLable">第一个停车计费时间（分钟）::</el-col>
                <el-col :span="5">
                  <el-input v-model="rateParamInfoObject.txtFirTime001"
                            :disabled="!curRowInfo.isEdit"
                            class="rateInput"></el-input>
                </el-col>
                <el-col :span="6"
                        class="el-form-item__label rateLable">第一个停车计费金额（元）::</el-col>
                <el-col :span="5">
                  <el-input v-model="rateParamInfoObject.txtFirAmt001"
                            :disabled="!curRowInfo.isEdit"
                            class="rateInput"></el-input>
                </el-col>
              </el-row>
              <el-row class="form-row">
                <el-col :span="8"
                        class="el-form-item__label rateLable">第二个停车计费时间（分钟）::</el-col>
                <el-col :span="5">
                  <el-input v-model="rateParamInfoObject.txtSecTime001"
                            :disabled="!curRowInfo.isEdit"
                            class="rateInput"></el-input>
                </el-col>
                <el-col :span="6"
                        class="el-form-item__label rateLable">第二个停车计费金额（元）::</el-col>
                <el-col :span="5">
                  <el-input v-model="rateParamInfoObject.txtSecAmt001"
                            :disabled="!curRowInfo.isEdit"
                            class="rateInput"></el-input>
                </el-col>
              </el-row>
              <el-row class="form-row">
                <el-col :span="8"
                        class="el-form-item__label rateLable">第三个停车计费时间（分钟）::</el-col>
                <el-col :span="5">
                  <el-input v-model="rateParamInfoObject.txtThiTime001"
                            :disabled="!curRowInfo.isEdit"
                            class="rateInput"></el-input>
                </el-col>
                <el-col :span="6"
                        class="el-form-item__label rateLable">第三个停车计费金额（元）::</el-col>
                <el-col :span="5">
                  <el-input v-model="rateParamInfoObject.txtThiAmt001"
                            :disabled="!curRowInfo.isEdit"
                            class="rateInput"></el-input>
                </el-col>
              </el-row>
              <el-row class="form-row">
                <el-col :span="8"
                        class="el-form-item__label rateLable">12小时连续停车收费上限（元）::</el-col>
                <el-col :span="5">
                  <el-input v-model="rateParamInfoObject.txt12UpAmt001"
                            :disabled="!curRowInfo.isEdit"
                            class="rateInput"></el-input>
                </el-col>
                <el-col :span="6"
                        class="el-form-item__label rateLable">24小时连续停车收费上限（元）::</el-col>
                <el-col :span="5">
                  <el-input v-model="rateParamInfoObject.txt24UpAmt001"
                            :disabled="!curRowInfo.isEdit"
                            class="rateInput"></el-input>
                </el-col>
              </el-row>
              <el-row class="form-row">
                <el-col :span="8"
                        class="el-form-item__label rateLable">第一个24小时连续停车收费上限（元）::</el-col>
                <el-col :span="5">
                  <el-input v-model="rateParamInfoObject.txtFir24UpAmt001"
                            :disabled="!curRowInfo.isEdit"
                            class="rateInput"></el-input>
                </el-col>
                <el-col :span="6"
                        class="el-form-item__label rateLable">停车时长不足一个计费单位时::</el-col>
                <el-col :span="5">
                  <el-select v-model="rateParamInfoObject.timeOut001"
                             filterable
                             :disabled="!curRowInfo.isEdit"
                             style="width: 100%">
                    <el-option v-for="item in timeOut"
                               :key="item.value"
                               :label="item.text"
                               :value="item.value">
                    </el-option>
                  </el-select>
                </el-col>
              </el-row>
              <el-row class="form-row">
                <el-col :span="8"
                        class="el-form-item__label rateLable">24小时停车收费上限的计费起始时间::</el-col>
                <el-col :span="5">
                  <el-select v-model="rateParamInfoObject.cbo24UpAmtTime001"
                             filterable
                             :disabled="!curRowInfo.isEdit"
                             style="width: 100%">
                    <el-option v-for="item in cbo24UpAmtTime"
                               :key="item.value"
                               :label="item.text"
                               :value="item.value">
                    </el-option>
                  </el-select>
                </el-col>
                <el-col :span="6"
                        class="el-form-item__label rateLable">免费时间使用方式::</el-col>
                <el-col :span="5">
                  <el-select v-model="rateParamInfoObject.freeTimeType001"
                             filterable
                             :disabled="!curRowInfo.isEdit"
                             style="width: 100%">
                    <el-option v-for="item in freeTimeTypes"
                               :key="item.value"
                               :label="item.text"
                               :value="item.value">
                    </el-option>
                  </el-select>
                </el-col>
              </el-row>
              <el-row  class="form-row">
               <el-col :span="4"
                        class="el-form-item__label rateLable">&nbsp;</el-col>
                <el-col :span="4">
                  <el-checkbox v-model="rateParamInfoObject.chkPass24HourTotAmt001"
                               :disabled="!curRowInfo.isEdit">启用24小时多次停车上限金额</el-checkbox>
                </el-col>
                <el-col :span="2"
                        style="line-height: 30px;margin-top: 5px"
                        align="center">&nbsp;</el-col>
                <el-col :span="3">&nbsp;</el-col>
                    <el-col :span="6"
                        class="el-form-item__label rateLable">收费上限（元）::</el-col>
                <el-col :span="5">
                     <el-input v-model="rateParamInfoObject.tb24HourParkAmt001"
                            :disabled="!curRowInfo.isEdit"
                            class="rateInput"></el-input>
                </el-col>
              </el-row>
              <el-row class="form-row">
                <el-col :span="4"
                        class="el-form-item__label rateLable">&nbsp;</el-col>
                <el-col :span="4">
                  <el-checkbox v-model="rateParamInfoObject.chk24PayTimes001"
                               :disabled="!curRowInfo.isEdit">24小时只收费一次</el-checkbox>
                </el-col>
                <el-col :span="2"
                        style="line-height: 30px;margin-top: 5px"
                        align="center">&nbsp;</el-col>
                <el-col :span="3">&nbsp;</el-col>
                <el-col :span="6"
                        class="el-form-item__label rateLable">24小时只收费一次的计算时间::</el-col>
                <el-col :span="5">
                  <el-select v-model="rateParamInfoObject.cbo24CalcTime001"
                             filterable
                             :disabled="!curRowInfo.isEdit"
                             style="width: 100%">
                    <el-option v-for="item in cbo24CalcTime"
                               :key="item.value"
                               :label="item.text"
                               :value="item.value">
                    </el-option>
                  </el-select>
                </el-col>
              </el-row>
              <el-row class="form-row">
                <el-col :span="4"
                        class="el-form-item__label rateLable">&nbsp;</el-col>
                <el-col :span="20">
                  <el-checkbox v-model="rateParamInfoObject.chk24Aga001"
                               :disabled="!curRowInfo.isEdit">停车满24小时后按此费率重新计算（不含免费时间）</el-checkbox>
                </el-col>
              </el-row>
              <el-row class="form-row">
                <el-col :span="4"
                        class="el-form-item__label rateLable">&nbsp;</el-col>
                <el-col :span="20">
                  <el-checkbox v-model="rateParamInfoObject.chkFreeTime001"
                               :disabled="!curRowInfo.isEdit">停车时间超过免费时间则免费时间也计算费用</el-checkbox>
                </el-col>
              </el-row>
              <el-row class="form-row">
                <el-col :span="4"
                        class="el-form-item__label rateLable">&nbsp;</el-col>
                <el-col :span="20">
                  <el-checkbox v-model="rateParamInfoObject.chk24TotalCalc"
                               :disabled="!curRowInfo.isEdit">24小时内进出场库停车时间累计计费（免费停车时间需累计）</el-checkbox>
                </el-col>
              </el-row>
            </el-form>
          </fieldset>
        </div>
        <div id="template2"
             v-if="curRowInfo.fTemplateID === '2'"
             style="padding-top: 5px;">
          <fieldset>
            <legend>标准费率二</legend>
            <el-form>
              <el-tabs v-model="templateactiveName"
                       type="border-card">
                <el-tab-pane label="日间时段"
                             name="first">
                  <el-row class="form-row">
                    <el-col :span="5"
                            class="el-form-item__label rateLable">时间段::</el-col>
                    <el-col :span="3">
                      <el-select v-model="rateParamInfoObject.startTime0021"
                                 filterable
                                 :disabled="!curRowInfo.isEdit"
                                 class="rateInput">
                        <el-option v-for="item in time"
                                   :key="item.value"
                                   :label="item.text"
                                   :value="item.value">
                        </el-option>
                      </el-select>
                    </el-col>
                    <el-col :span="2"
                            style="line-height: 30px;margin-top: 5px"
                            align="center">至</el-col>
                    <el-col :span="3">
                      <el-select v-model="rateParamInfoObject.endTime0021"
                                 filterable
                                 :disabled="!curRowInfo.isEdit"
                                 class="rateInput">
                        <el-option v-for="item in time"
                                   :key="item.value"
                                   :label="item.text"
                                   :value="item.value">
                        </el-option>
                      </el-select>
                    </el-col>
                    <el-col :span="6"
                            class="el-form-item__label rateLable">免费停车时间（分钟）::</el-col>
                    <el-col :span="5">
                      <el-input v-model="rateParamInfoObject.txtFreeTime0021"
                                :disabled="!curRowInfo.isEdit"
                                class="rateInput"></el-input>
                    </el-col>
                  </el-row>
                  <el-row class="form-row">
                    <el-col :span="8"
                            class="el-form-item__label rateLable text-red">标准停车计费时间（分钟）::</el-col>
                    <el-col :span="5">
                      <el-input v-model="rateParamInfoObject.txtCalcTime0021"
                                :disabled="!curRowInfo.isEdit"
                                class="rateInput"></el-input>
                    </el-col>
                    <el-col :span="6"
                            class="el-form-item__label rateLable text-red">标准停车计费金额（元）::</el-col>
                    <el-col :span="5">
                      <el-input v-model="rateParamInfoObject.txtCalcAmt0021"
                                :disabled="!curRowInfo.isEdit"
                                class="rateInput"></el-input>
                    </el-col>
                  </el-row>
                  <el-row class="form-row">
                    <el-col :span="8"
                            class="el-form-item__label rateLable">标准停车计费时间二（分钟）::</el-col>
                    <el-col :span="5">
                      <el-input v-model="rateParamInfoObject.txtCalcTime00212"
                                :disabled="!curRowInfo.isEdit"
                                class="rateInput"></el-input>
                    </el-col>
                    <el-col :span="6"
                            class="el-form-item__label rateLable">标准停车计费金额二（元）::</el-col>
                    <el-col :span="5">
                      <el-input v-model="rateParamInfoObject.txtCalcAmt00212"
                                :disabled="!curRowInfo.isEdit"
                                class="rateInput"></el-input>
                    </el-col>
                  </el-row>
                  <el-row class="form-row">
                    <el-col :span="8"
                            class="el-form-item__label rateLable">第一个停车计费时间（分钟）::</el-col>
                    <el-col :span="5">
                      <el-input v-model="rateParamInfoObject.txtFirTime0021"
                                :disabled="!curRowInfo.isEdit"
                                class="rateInput"></el-input>
                    </el-col>
                    <el-col :span="6"
                            class="el-form-item__label rateLable">第一个停车计费金额（元）::</el-col>
                    <el-col :span="5">
                      <el-input v-model="rateParamInfoObject.txtFirAmt0021"
                                :disabled="!curRowInfo.isEdit"
                                class="rateInput"></el-input>
                    </el-col>
                  </el-row>
                  <el-row class="form-row">
                    <el-col :span="8"
                            class="el-form-item__label rateLable">第二个停车计费时间（分钟）::</el-col>
                    <el-col :span="5">
                      <el-input v-model="rateParamInfoObject.txtSecTime0021"
                                :disabled="!curRowInfo.isEdit"
                                class="rateInput"></el-input>
                    </el-col>
                    <el-col :span="6"
                            class="el-form-item__label rateLable">第二个停车计费金额（元）::</el-col>
                    <el-col :span="5">
                      <el-input v-model="rateParamInfoObject.txtSecAmt0021"
                                :disabled="!curRowInfo.isEdit"
                                class="rateInput"></el-input>
                    </el-col>
                  </el-row>
                  <el-row class="form-row">
                    <el-col :span="8"
                            class="el-form-item__label rateLable">第三个停车计费时间（分钟）::</el-col>
                    <el-col :span="5">
                      <el-input v-model="rateParamInfoObject.txtThiTime0021"
                                :disabled="!curRowInfo.isEdit"
                                class="rateInput"></el-input>
                    </el-col>
                    <el-col :span="6"
                            class="el-form-item__label rateLable">第三个停车计费金额（元）::</el-col>
                    <el-col :span="5">
                      <el-input v-model="rateParamInfoObject.txtThiAmt0021"
                                :disabled="!curRowInfo.isEdit"
                                class="rateInput"></el-input>
                    </el-col>
                  </el-row>
                  <el-row class="form-row">
                    <el-col :span="8"
                            class="el-form-item__label rateLable">本时段连续停车收费上限（元）::</el-col>
                    <el-col :span="5">
                      <el-input v-model="rateParamInfoObject.txtTimSecUpAmt0021"
                                :disabled="!curRowInfo.isEdit"
                                class="rateInput"></el-input>
                    </el-col>
                    <el-col :span="6"
                            class="el-form-item__label rateLable">
                      <el-checkbox v-model="rateParamInfoObject.chkTimeSecPayTime21"
                                   :disabled="!curRowInfo.isEdit">本时段只收费一次 </el-checkbox>
                    </el-col>
                  </el-row>
                </el-tab-pane>
                <el-tab-pane label="夜间时段"
                             name="second">
                  <el-row class="form-row">
                    <el-col :span="5"
                            class="el-form-item__label rateLable">时间段::</el-col>
                    <el-col :span="3">
                      <el-select v-model="rateParamInfoObject.startTime0022"
                                 filterable
                                 :disabled="!curRowInfo.isEdit"
                                 class="rateInput">
                        <el-option v-for="item in time"
                                   :key="item.value"
                                   :label="item.text"
                                   :value="item.value">
                        </el-option>
                      </el-select>
                    </el-col>
                    <el-col :span="2"
                            style="line-height: 30px;margin-top: 5px"
                            align="center">至</el-col>
                    <el-col :span="3">
                      <el-select v-model="rateParamInfoObject.endTime0022"
                                 filterable
                                 :disabled="!curRowInfo.isEdit"
                                 class="rateInput">
                        <el-option v-for="item in time"
                                   :key="item.value"
                                   :label="item.text"
                                   :value="item.value">
                        </el-option>
                      </el-select>
                    </el-col>
                    <el-col :span="6"
                            class="el-form-item__label rateLable">免费停车时间（分钟）::</el-col>
                    <el-col :span="5">
                      <el-input v-model="rateParamInfoObject.txtFreeTime0022"
                                :disabled="!curRowInfo.isEdit"
                                class="rateInput"></el-input>
                    </el-col>
                  </el-row>
                  <el-row class="form-row">
                    <el-col :span="8"
                            class="el-form-item__label rateLable text-red">标准停车计费时间（分钟）::</el-col>
                    <el-col :span="5">
                      <el-input v-model="rateParamInfoObject.txtCalcTime0022"
                                :disabled="!curRowInfo.isEdit"
                                class="rateInput"></el-input>
                    </el-col>
                    <el-col :span="6"
                            class="el-form-item__label rateLable text-red">标准停车计费金额（元）::</el-col>
                    <el-col :span="5">
                      <el-input v-model="rateParamInfoObject.txtCalcAmt0022"
                                :disabled="!curRowInfo.isEdit"
                                class="rateInput"></el-input>
                    </el-col>
                  </el-row>
                  <el-row class="form-row">
                    <el-col :span="8"
                            class="el-form-item__label rateLable">标准停车计费时间二（分钟）::</el-col>
                    <el-col :span="5">
                      <el-input v-model="rateParamInfoObject.txtCalcTime00222"
                                :disabled="!curRowInfo.isEdit"
                                class="rateInput"></el-input>
                    </el-col>
                    <el-col :span="6"
                            class="el-form-item__label rateLable">标准停车计费金额二（元）::</el-col>
                    <el-col :span="5">
                      <el-input v-model="rateParamInfoObject.txtCalcAmt00222"
                                :disabled="!curRowInfo.isEdit"
                                class="rateInput"></el-input>
                    </el-col>
                  </el-row>
                  <el-row class="form-row">
                    <el-col :span="8"
                            class="el-form-item__label rateLable">第一个停车计费时间（分钟）::</el-col>
                    <el-col :span="5">
                      <el-input v-model="rateParamInfoObject.txtFirTime0022"
                                :disabled="!curRowInfo.isEdit"
                                class="rateInput"></el-input>
                    </el-col>
                    <el-col :span="6"
                            class="el-form-item__label rateLable">第一个停车计费金额（元）::</el-col>
                    <el-col :span="5">
                      <el-input v-model="rateParamInfoObject.txtFirAmt0022"
                                :disabled="!curRowInfo.isEdit"
                                class="rateInput"></el-input>
                    </el-col>
                  </el-row>
                  <el-row class="form-row">
                    <el-col :span="8"
                            class="el-form-item__label rateLable">第二个停车计费时间（分钟）::</el-col>
                    <el-col :span="5">
                      <el-input v-model="rateParamInfoObject.txtSecTime0022"
                                :disabled="!curRowInfo.isEdit"
                                class="rateInput"></el-input>
                    </el-col>
                    <el-col :span="6"
                            class="el-form-item__label rateLable">第二个停车计费金额（元）::</el-col>
                    <el-col :span="5">
                      <el-input v-model="rateParamInfoObject.txtSecAmt0022"
                                :disabled="!curRowInfo.isEdit"
                                class="rateInput"></el-input>
                    </el-col>
                  </el-row>
                  <el-row class="form-row">
                    <el-col :span="8"
                            class="el-form-item__label rateLable">第三个停车计费时间（分钟）::</el-col>
                    <el-col :span="5">
                      <el-input v-model="rateParamInfoObject.txtThiTime0022"
                                :disabled="!curRowInfo.isEdit"
                                class="rateInput"></el-input>
                    </el-col>
                    <el-col :span="6"
                            class="el-form-item__label rateLable">第三个停车计费金额（元）::</el-col>
                    <el-col :span="5">
                      <el-input v-model="rateParamInfoObject.txtThiAmt0022"
                                :disabled="!curRowInfo.isEdit"
                                class="rateInput"></el-input>
                    </el-col>
                  </el-row>
                  <el-row class="form-row">
                    <el-col :span="8"
                            class="el-form-item__label rateLable">本时段连续停车收费上限（元）::</el-col>
                    <el-col :span="5">
                      <el-input v-model="rateParamInfoObject.txtTimSecUpAmt0022"
                                :disabled="!curRowInfo.isEdit"
                                class="rateInput"></el-input>
                    </el-col>
                    <el-col :span="6"
                            class="el-form-item__label rateLable">
                      <el-checkbox v-model="rateParamInfoObject.chkTimeSecPayTime22"
                                   :disabled="!curRowInfo.isEdit">本时段只收费一次 </el-checkbox>
                    </el-col>
                  </el-row>
                </el-tab-pane>
              </el-tabs>
              <el-row class="form-row">
                <el-col :span="8"
                        class="el-form-item__label rateLable">第一个24小时连续停车收费上限（元）::</el-col>
                <el-col :span="5">
                  <el-input v-model="rateParamInfoObject.txt24UpAmt002"
                            :disabled="!curRowInfo.isEdit"
                            class="rateInput"></el-input>
                </el-col>
                <el-col :span="6"
                        class="el-form-item__label rateLable">24小时连续停车收费上限（元）::</el-col>
                <el-col :span="5">
                  <el-input v-model="rateParamInfoObject.txtFir24UpAmt002"
                            :disabled="!curRowInfo.isEdit"
                            class="rateInput"></el-input>
                </el-col>
              </el-row>
              <el-row class="form-row">
                <el-col :span="8"
                        class="el-form-item__label rateLable">24小时停车收费上限的计费起始时间::</el-col>
                <el-col :span="5">
                  <el-select v-model="rateParamInfoObject.cbo24UpAmtTime002"
                             filterable
                             :disabled="!curRowInfo.isEdit"
                             style="width:100%"
                             class="rateInput">
                    <el-option v-for="item in cbo24UpAmtTime"
                               :key="item.value"
                               :label="item.text"
                               :value="item.value">
                    </el-option>
                  </el-select>
                </el-col>
                <el-col :span="2"
                        class="el-form-item__label">&nbsp;</el-col>
                <el-col :span="8"
                        style="line-height:32px;">
                  <el-checkbox v-model="rateParamInfoObject.chkFreeTime002"
                               :disabled="!curRowInfo.isEdit">停车时间超过免费时间则免费时间也计费</el-checkbox>
                </el-col>
              </el-row>
              <el-row class="form-row">
                <el-col :span="8"
                        class="el-form-item__label rateLable">停车时长不足一个计费单位的处理方式::</el-col>
                <el-col :span="5">
                  <el-select v-model="rateParamInfoObject.timeOut002"
                             filterable
                             :disabled="!curRowInfo.isEdit"
                             style="width:100%"
                             class="rateInput">
                    <el-option v-for="item in timeOut"
                               :key="item.value"
                               :label="item.text"
                               :value="item.value">
                    </el-option>
                  </el-select>
                </el-col>
                <el-col :span="6"
                        class="el-form-item__label rateLable">免费时间使用方式::</el-col>
                <el-col :span="5">
                  <el-select v-model="rateParamInfoObject.freeTimeType002"
                             filterable
                             :disabled="!curRowInfo.isEdit"
                             style="width: 100%">
                    <el-option v-for="item in freeTimeTypes"
                               :key="item.value"
                               :label="item.text"
                               :value="item.value">
                    </el-option>
                  </el-select>
                </el-col>
              </el-row>
              <el-row class="form-row">
                <el-col :span="3"
                        class="el-form-item__label">&nbsp;</el-col>
                <el-col :span="9"
                        style="line-height:32px;">
                  <el-checkbox v-model="rateParamInfoObject.chk24Aga002"
                               :disabled="!curRowInfo.isEdit">停车满24小时后按此费率重新计算（不含免费时间）</el-checkbox>
                </el-col>
                <el-col :span="3"
                        class="el-form-item__label">&nbsp;</el-col>
                <el-col :span="9"
                        style="line-height:32px;">
                  <el-checkbox v-model="rateParamInfoObject.chk24AgaCon002"
                               :disabled="!curRowInfo.isEdit">停车满24小时后按此费率重新计算（含免费时间）</el-checkbox>
                </el-col>
              </el-row>
              <el-row class="form-row">
                    <el-col :span="3"
                        class="el-form-item__label">&nbsp;</el-col>
                <el-col :span="3"
                        style="line-height:32px;">
                  <el-checkbox v-model="rateParamInfoObject.chkTotalTimePay002"
                               :disabled="!curRowInfo.isEdit">首时段累计计费</el-checkbox>
                </el-col>
                <el-col :span="5"
                        class="el-form-item__label">跨时段停车时的费率处理方式::</el-col>
                <el-col :span="5">
                  <el-select v-model="rateParamInfoObject.crossTimeSec"
                             filterable
                             :disabled="!curRowInfo.isEdit"
                             style="width:100%"
                             class="rateInput">
                    <el-option v-for="item in crossTimeSec"
                               :key="item.value"
                               :label="item.text"
                               :value="item.value">
                    </el-option>
                  </el-select>
                </el-col>
              </el-row>
              <el-row class="form-row">
                <el-col :span="3"
                        class="el-form-item__label ">&nbsp;</el-col>
                <el-col :span="3"
                        style="line-height:32px;">
                  <el-checkbox v-model="rateParamInfoObject.chk24PayTimes002"
                               :disabled="!curRowInfo.isEdit">24小时只收费一次</el-checkbox>
                </el-col>

                <el-col :span="5"
                        class="el-form-item__label ">24小时只收费一次的计算时间::</el-col>
                <el-col :span="5"
                        style="line-height:32px;">
                  <el-select v-model="rateParamInfoObject.cbo24CalcTime002"
                             filterable
                             style="width:100%"
                             :disabled="!curRowInfo.isEdit">
                    <el-option v-for="item in cbo24CalcTime"
                               :key="item.value"
                               :label="item.text"
                               :value="item.value">
                    </el-option>
                  </el-select>
                </el-col>
              </el-row>
            </el-form>
          </fieldset>
        </div>
        <div id="template3"
             v-if="curRowInfo.fTemplateID === '3'"
             style="padding-top: 5px;">
          <fieldset>
            <legend>自定义费率</legend>
            <el-form :inline="true">
              <el-row>
                <el-col :span="12">
                  <el-form-item label="免费停车时间（分钟）::">
                    <el-input v-model="rateParamInfoObject.txtFreeTime003"
                              :disabled="!curRowInfo.isEdit"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="">
                    <el-checkbox v-model="rateParamInfoObject.chkFreeTime003"
                                 :disabled="!curRowInfo.isEdit">停车超过免费时间时则免费时间也计费</el-checkbox>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="24">
                  <el-input type="textarea"
                            :rows="18"
                            v-model="rateParamInfoObject.rchScript"
                            :disabled="!curRowInfo.isEdit"></el-input>
                </el-col>
              </el-row>
            </el-form>
          </fieldset>
        </div>
        <div id="template4"
             v-if="curRowInfo.fTemplateID === '4'"
             style="padding-top: 5px;">
          <fieldset>
            <legend>手持机出场应急收费费率</legend>
            <el-form>
              <el-row class="form-row">
                <el-col :span="5"
                        class="el-form-item__label rateLable">时间段::</el-col>
                <el-col :span="3">
                  <el-select v-model="rateParamInfoObject.pdastartTime001"
                             filterable
                             :disabled="true"
                             class="rateInput">
                    <el-option v-for="item in time"
                               :key="item.value"
                               :label="item.text"
                               :value="item.value">
                    </el-option>
                  </el-select>
                </el-col>
                <el-col :span="2"
                        style="line-height: 30px;"
                        align="center">至</el-col>
                <el-col :span="3">
                  <el-select v-model="rateParamInfoObject.pdaendTime001"
                             filterable
                             :disabled="true"
                             class="rateInput">
                    <el-option v-for="item in time"
                               :key="item.value"
                               :label="item.text"
                               :value="item.value">
                    </el-option>
                  </el-select>
                </el-col>
                <el-col :span="6"
                        class="el-form-item__label rateLable">免费停车时间（分钟）::</el-col>
                <el-col :span="5">
                  <el-input v-model="rateParamInfoObject.pdatxtFreeTime001"
                            :disabled="!curRowInfo.isEdit"
                            class="rateInput"></el-input>
                </el-col>
              </el-row>
              <el-row class="form-row">
                <el-col :span="8"
                        class="el-form-item__label rateLable text-red">标准停车计费时间（分钟）::</el-col>
                <el-col :span="5">
                  <el-input v-model="rateParamInfoObject.pdatxtCalcTime001"
                            :disabled="!curRowInfo.isEdit"
                            class="rateInput"></el-input>
                </el-col>
                <el-col :span="6"
                        class="el-form-item__label rateLable text-red">标准停车计费金额（元）::</el-col>
                <el-col :span="5">
                  <el-input v-model="rateParamInfoObject.pdatxtCalcAmt001"
                            :disabled="!curRowInfo.isEdit"
                            class="rateInput"></el-input>
                </el-col>
              </el-row>
              <el-row class="form-row">
                <el-col :span="8"
                        class="el-form-item__label rateLable">标准停车计费时间二（分钟）::</el-col>
                <el-col :span="5">
                  <el-input v-model="rateParamInfoObject.pdatxtCalcTime002"
                            :disabled="!curRowInfo.isEdit"
                            class="rateInput"></el-input>
                </el-col>
                <el-col :span="6"
                        class="el-form-item__label rateLable">标准停车计费金额二（元）::</el-col>
                <el-col :span="5">
                  <el-input v-model="rateParamInfoObject.pdatxtCalcAmt002"
                            :disabled="!curRowInfo.isEdit"
                            class="rateInput"></el-input>
                </el-col>
              </el-row>
              <el-row class="form-row">
                <el-col :span="8"
                        class="el-form-item__label rateLable">第一个停车计费时间（分钟）::</el-col>
                <el-col :span="5">
                  <el-input v-model="rateParamInfoObject.pdatxtFirTime001"
                            :disabled="!curRowInfo.isEdit"
                            class="rateInput"></el-input>
                </el-col>
                <el-col :span="6"
                        class="el-form-item__label rateLable">第一个停车计费金额（元）::</el-col>
                <el-col :span="5">
                  <el-input v-model="rateParamInfoObject.pdatxtFirAmt001"
                            :disabled="!curRowInfo.isEdit"
                            class="rateInput"></el-input>
                </el-col>
              </el-row>
              <el-row class="form-row">
                <el-col :span="8"
                        class="el-form-item__label rateLable">第二个停车计费时间（分钟）::</el-col>
                <el-col :span="5">
                  <el-input v-model="rateParamInfoObject.pdatxtSecTime001"
                            :disabled="!curRowInfo.isEdit"
                            class="rateInput"></el-input>
                </el-col>
                <el-col :span="6"
                        class="el-form-item__label rateLable">第二个停车计费金额（元）::</el-col>
                <el-col :span="5">
                  <el-input v-model="rateParamInfoObject.pdatxtSecAmt001"
                            :disabled="!curRowInfo.isEdit"
                            class="rateInput"></el-input>
                </el-col>
              </el-row>
              <el-row class="form-row">
                <el-col :span="8"
                        class="el-form-item__label rateLable">第三个停车计费时间（分钟）::</el-col>
                <el-col :span="5">
                  <el-input v-model="rateParamInfoObject.pdatxtThiTime001"
                            :disabled="!curRowInfo.isEdit"
                            class="rateInput"></el-input>
                </el-col>
                <el-col :span="6"
                        class="el-form-item__label rateLable">第三个停车计费金额（元）::</el-col>
                <el-col :span="5">
                  <el-input v-model="rateParamInfoObject.pdatxtThiAmt001"
                            :disabled="!curRowInfo.isEdit"
                            class="rateInput"></el-input>
                </el-col>
              </el-row>
              <el-row class="form-row">
                <el-col :span="8"
                        class="el-form-item__label rateLable">12小时连续停车收费上限（元）::</el-col>
                <el-col :span="5">
                  <el-input v-model="rateParamInfoObject.pdatxt12UpAmt001"
                            :disabled="!curRowInfo.isEdit"
                            class="rateInput"></el-input>
                </el-col>
                <el-col :span="6"
                        class="el-form-item__label rateLable">24小时连续停车收费上限（元）::</el-col>
                <el-col :span="5">
                  <el-input v-model="rateParamInfoObject.pdatxt24UpAmt001"
                            :disabled="!curRowInfo.isEdit"
                            class="rateInput"></el-input>
                </el-col>
              </el-row>
              <el-row class="form-row">
                <el-col :span="8"
                        class="el-form-item__label rateLable">第一个24小时连续停车收费上限（元）::</el-col>
                <el-col :span="5">
                  <el-input v-model="rateParamInfoObject.pdatxtFir24UpAmt001"
                            :disabled="!curRowInfo.isEdit"
                            class="rateInput"></el-input>
                </el-col>
                <el-col :span="6"
                        class="el-form-item__label rateLable">停车时长不足一个计费单位时::</el-col>
                <el-col :span="5">
                  <el-select v-model="rateParamInfoObject.pdatimeOut001"
                             filterable
                             :disabled="!curRowInfo.isEdit"
                             style="width: 100%">
                    <el-option v-for="item in timeOut"
                               :key="item.value"
                               :label="item.text"
                               :value="item.value">
                    </el-option>
                  </el-select>
                </el-col>
              </el-row>
              <el-row class="form-row">
                <el-col :span="4"
                        class="el-form-item__label rateLable">&nbsp;</el-col>
                <el-col :span="20">
                  <el-checkbox v-model="rateParamInfoObject.pdachk24Aga001"
                               :disabled="!curRowInfo.isEdit">停车满24小时后按此费率重新计算（不含免费时间）</el-checkbox>
                </el-col>
              </el-row>
              <el-row class="form-row">
                <el-col :span="4"
                        class="el-form-item__label rateLable">&nbsp;</el-col>
                <el-col :span="20">
                  <el-checkbox v-model="rateParamInfoObject.pdachkFreeTime001"
                               :disabled="!curRowInfo.isEdit">停车时间超过免费时间则免费时间也计算费用</el-checkbox>
                </el-col>
              </el-row>
            </el-form>
          </fieldset>
        </div>
        <div slot="footer"
             class="dialog-footer">
          <el-button type="primary"
                     @click="submitForm('form')"
                     :loading="save_loading"
                     v-if="curRowInfo.isEdit">{{save_msg}}</el-button>
          <el-button @click="rateEditOrDetail = false">取消</el-button>
        </div>
      </el-dialog>
      <el-dialog title="批量下发"
                 :visible.sync="synDataVisible"
                 width="450px"
                 v-dialogDrag>
        <el-form label-width="100px"
                 :model="syncData"
                 :rules="synRules"
                 ref="ruleForm"
                 style="margin-top:20px">
          <el-form-item label="选择客户::"
                        prop="fCustID">
            <el-select v-model="syncData.fCustID"
                       filterable
                       style="width:250px"
                       placeholder="请选择客户">
              <el-option v-for="item in offlineCusts"
                         :key="item.fCustID"
                         :label="item.unionName"
                         :value="item.fCustID">
              </el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <div slot="footer"
             class="dialog-footer">
          <el-button type="primary"
                     @click="syncAllOk('ruleForm')">确定</el-button>
          <el-button @click="synDataVisible = false">取消</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import * as api from '@/api/rate'
export default {
  name: 'rateMain.vue',
  data () {
    return {
      rateActiveName: 'rateList',
      navigationMap: {
        rateList: '费率列表',
        synRateList: '待同步'
      },
      loading: false,
      defaultValue: {
        rateTemplate_defaultValue: '',
        crossTimeSec_defaultValue: '',
        cbo24CalcTime_defaultValue: '',
        timeOut_defaultValue: '',
        freeTimeTypes_defaultValue: '',
        cbo24UpAmtTime_defaultValue: ''
      },
      synDataVisible: false,
      syncData: {
        fCustID: ''
      },
      synRules: {
        fCustID: [
          { required: true, message: '请选择客户', trigger: 'change' }
        ]
      },
      save_loading: false,
      save_msg: '保存',
      is_edit: false,
      is_del: false,
      is_syn: false,
      // custName: '',
      time: [],
      rateTemplate: [],
      timeOut: [],
      crossTimeSec: [],
      cbo24UpAmtTime: [],
      cbo24CalcTime: [],
      freeTimeTypes: [],
      rateType: [{ value: '1', text: '节假日费率' }, { value: '0', text: '普通日费率' }],
      templateactiveName: 'first',
      rateParamInfoObject: {
        startTime001: '00:00',
        endTime001: '24:00',
        txtFreeTime001: '',
        txtCalcTime001: '',
        txtCalcAmt001: '',
        txtFirTime001: '',
        txtFirAmt001: '',
        txtSecTime001: '',
        txtSecAmt001: '',
        txtThiTime001: '',
        txtThiAmt001: '',
        txt12UpAmt001: '',
        txt24UpAmt001: '',
        txtFir24UpAmt001: '',
        timeOut001: '',
        chk24Aga001: '',
        chkFreeTime001: '',
        chk24PayTimes001: '',
        chkPass24HourTotAmt001: '',
        cbo24CalcTime001: '',
        startTime0021: '',
        endTime0021: '',
        txtFreeTime0021: '',
        txtCalcTime0021: '',
        txtCalcAmt0021: '',
        txtFirTime0021: '',
        txtFirAmt0021: '',
        txtSecTime0021: '',
        txtSecAmt0021: '',
        txtThiTime0021: '',
        txtThiAmt0021: '',
        txtTimSecUpAmt0021: '',
        txtCalcTime002: '',
        txtCalcAmt002: '',
        txtCalcTime00212: '',
        txtCalcAmt00212: '',
        txtCalcTime00222: '',
        txtCalcAmt00222: '',
        chkTimeSecPayTime21: false,
        chkTimeSecPayTime22: false,
        startTime0022: '',
        endTime0022: '',
        txtFreeTime0022: '',
        txtCalcTime0022: '',
        txtCalcAmt0022: '',
        txtFirTime0022: '',
        txtFirAmt0022: '',
        txtSecTime0022: '',
        txtSecAmt0022: '',
        txtThiTime0022: '',
        txtThiAmt0022: '',
        txtTimSecUpAmt0022: '',
        txt24UpAmt002: '',
        txtFir24UpAmt002: '',
        timeOut002: '',
        chk24Aga002: '',
        chk24AgaCon002: '',
        chkTotalTimePay002: '',
        chkFreeTime002: '',
        crossTimeSec: '',
        chk24PayTimes002: '',
        cbo24CalcTime002: '',
        freeTimeType001: '',
        freeTimeType002: '',
        cbo24UpAmtTime001: '',
        cbo24UpAmtTime002: '',
        chk24TotalCalc: '',
        txtFreeTime003: '',
        chkFreeTime003: false,
        rchScript: '',
        pdastartTime001: '00:00',
        pdaendTime001: '24:00',
        pdatxtFreeTime001: '',
        pdatxtCalcTime001: '',
        pdatxtCalcAmt001: '',
        pdatxtCalcTime002: '',
        pdatxtCalcAmt002: '',
        pdatxtFirTime001: '',
        pdatxtFirAmt001: '',
        pdatxtSecTime001: '',
        pdatxtSecAmt001: '',
        pdatxtThiTime001: '',
        pdatxtThiAmt001: '',
        pdatxt12UpAmt001: '',
        pdatxt24UpAmt001: '',
        pdatxtFir24UpAmt001: '',
        tb24HourParkAmt001: '',
        pdatimeOut001: '',
        pdachk24Aga001: '',
        pdachkFreeTime001: ''
      },
      curRowInfo: {
        fCustID: '',
        fCustNo: '',
        fRateName: '',
        fTemplateID: '1',
        fIsHoliday: 1,
        fRemark: ''
      },
      rateEditOrDetail: false,
      rateBaseInfoList: [],
      rateParamInfoList: [],
      detailVisible: false,
      activeName: 'rateBaseInfo',
      detailTitle: '',
      bindQueryInput: '',
      selCustID: '',
      currentRow: null,
      choiceCusts: [],
      offlineCusts: [],
      rateList: [],
      synRateList: [],
      tableHeight: 0,
      form: {

      },
      pageSize: 20,
      pageNo: 1,
      total: 0
    }
  },
  methods: {
    ...mapActions([
      'getCustByGroup', 'getRateByQuery', 'getRateParamById', 'loadRateDDLSource', 'saveRate', 'deleteRate', 'synRateById', 'getCurrentUserPers'
    ]),
    submitForm (formName) {
      console.log(this.curRowInfo)
      if ((this.curRowInfo.fCustID || '').trim().length <= 0) {
        this.$message.error('请先选择客户')
        return false
      }
      // let tmpCust = this.choiceCusts.filter(item => {
      //   if (item.fCustID === this.curRowInfo.fCustID) { return item }
      // })
      // this.curRowInfo.fCustNo = tmpCust[0].fCustNo
      let param = {}
      param.curRowInfo = this.curRowInfo
      param.rateParamInfoObject = this.rateParamInfoObject
      this.save_loading = true
      this.save_msg = '保存中…'
      this.saveRate(param).then(res => {
        this.save_loading = false
        this.save_msg = '保存'
        let { status, data } = res
        if (status === 200) {
          if (data.IsOk) {
            this.rateEditOrDetail = false
            this.initData()
            this.$message({
              type: 'success',
              message: data.Msg
            })
          } else {
            this.$message.error(data.Msg)
          }
        }
      })
    },
    syncAllRate () {
      this.syncData.fCustID = ''
      this.synDataVisible = true
    },
    tabClick () {
      this.pageNo = 1
      this.total = 0
      this.initData()
    },
    indexMethod (index) {
      return this.pageSize * (this.pageNo - 1) + index + 1
    },
    handleSizeChange (value) {
      this.pageSize = value
      this.initData()
    },
    handlePage (index) {
      this.pageNo = index
      this.initData()
    },
    detailClick (rowInfo) {
      this.activeName = 'rateBaseInfo'
      this.rateBaseInfoList = []
      this.rateParamInfoList = []
      if (rowInfo && rowInfo !== null && typeof (rowInfo) !== 'undefined') {
        let chnlInfo = {
          'fRateName': '费率名称',
          'rateTemplate': '费率模板',
          'holidayName': '费率类型',
          'fRemark': '费率说明'
        }
        for (var key in chnlInfo) {
          let pinfo = {}
          pinfo['fItemName'] = chnlInfo[key]
          pinfo['fItemValue'] = rowInfo[key]
          this.rateBaseInfoList.push(pinfo)
        }
        // let param = {}
        // param['fRateID'] = rowInfo.fRateID
        // param['fCustID'] = rowInfo.fCustID
        api.getRateParamById({ fBigRowID: rowInfo.fBigRowID, fIsSyn: this.rateActiveName === 'synRateList' }).then(res => {
          let { status, data } = res
          if (status === 200) {
            if (data.IsOk) {
              let tmpRateParam = []
              Object.assign(tmpRateParam, data.Data)
              this.rateParamInfoList = tmpRateParam
              this.detailTitle = '查看 ' + rowInfo.fRateName + ' 配置信息'
              this.detailVisible = true
            }
          }
        })
      }
    },
    viewRate (rowInfo) {
      if (rowInfo && rowInfo !== null && typeof (rowInfo) !== 'undefined') {
        this.updateRate(rowInfo, false, 'edit')
      } else { console.log('查看费率行数据不对') }
    },
    updateRate (rowInfo, isEdit, op) {
      this.setDefault()
      this.detailTitle = '【' + rowInfo.fCustName + '】' + rowInfo.fRateName
      this.curRowInfo.isEdit = isEdit
      this.curRowInfo.fIsSyn = this.rateActiveName === 'synRateList'
      this.curRowInfo.op = op
      Object.assign(this.curRowInfo, rowInfo)
      // let param = {}
      // param['fRateID'] = rowInfo.fRateID
      // param['fCustID'] = rowInfo.fCustID
      // param['fTemplateID'] = rowInfo.fTemplateID
      // param['rateActiveName'] = this.rateActiveName
      this.getRateParamById({ fBigRowID: rowInfo.fBigRowID, fIsSyn: this.rateActiveName === 'synRateList' }).then(res => {
        let { status, data } = res
        if (status === 200) {
          if (data.IsOk) {
            Object.assign(this.rateParamInfoObject, data.Data)
            console.log(this.rateParamInfoObject)
            this.rateEditOrDetail = true
          }
        }
      })
    },
    setDefault () {
      this.templateactiveName = 'first'
      for (let key in this.curRowInfo) {
        this.curRowInfo[key] = ''
      }
      for (let key in this.rateParamInfoObject) {
        this.rateParamInfoObject[key] = ''
      }
      this.curRowInfo.fTemplateID = this.defaultValue.rateTemplate_defaultValue
      this.curRowInfo.fIsHoliday = '0'

      this.rateParamInfoObject.startTime001 = '00:00'
      this.rateParamInfoObject.endTime001 = '24:00'
      this.rateParamInfoObject.timeOut001 = this.defaultValue.timeOut_defaultValue
      this.rateParamInfoObject.cbo24CalcTime001 = this.defaultValue.cbo24CalcTime_defaultValue
      this.rateParamInfoObject.startTime0021 = '08:00'
      this.rateParamInfoObject.endTime0021 = '20:00'
      this.rateParamInfoObject.startTime0022 = '20:00'
      this.rateParamInfoObject.endTime0022 = '08:00'
      this.rateParamInfoObject.timeOut002 = this.defaultValue.timeOut_defaultValue
      this.rateParamInfoObject.cbo24CalcTime002 = this.defaultValue.cbo24CalcTime_defaultValue
      this.rateParamInfoObject.crossTimeSec = this.defaultValue.crossTimeSec_defaultValue
      this.rateParamInfoObject.freeTimeType001 = this.defaultValue.freeTimeTypes_defaultValue
      this.rateParamInfoObject.freeTimeType002 = this.defaultValue.freeTimeTypes_defaultValue
      this.rateParamInfoObject.cbo24UpAmtTime001 = this.defaultValue.cbo24UpAmtTime_defaultValue
      this.rateParamInfoObject.cbo24UpAmtTime002 = this.defaultValue.cbo24UpAmtTime_defaultValue

      this.rateParamInfoObject.pdastartTime001 = '00:00'
      this.rateParamInfoObject.pdaendTime001 = '24:00'
      this.rateParamInfoObject.pdatimeOut001 = this.defaultValue.timeOut_defaultValue
    },
    addSyncRate () {
      this.setDefault()
      this.rateEditOrDetail = true
      this.curRowInfo.op = 'add'
      this.curRowInfo.isEdit = true
      this.detailTitle = '新增费率'
    },
    syncAllOk (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let tmpCust = this.choiceCusts.filter(item => {
            if (item.fCustID === this.syncData.fCustID) { return item }
          })
          var isSyn = this.rateActiveName === 'synRateList'
          var tip = '将客户[' + tmpCust[0].fCustName + ']的【费率列表】费率，从云平台批量下发同步到线下客户端, 是否继续?'
          var synTip = '将客户[' + tmpCust[0].fCustName + ']的【待同步】费率，从云平台批量下发同步到线下客户端, 是否继续?'
          this.$confirm(isSyn ? synTip : tip, '提示', {
            cancelButtonText: '取消',
            confirmButtonText: '确定',
            type: 'warning'
          }).then(() => {
            this.synRateById({
              fCustID: this.syncData.fCustID,
              fIsSyn: isSyn
            }).then(res => {
              if (res && res.data) {
                let { status, data } = res
                if (status === 200) {
                  if (data.IsOk) {
                    this.$message({
                      type: 'success',
                      message: '操作完成'
                    })
                    this.synDataVisible = false
                  } else {
                    this.$message.error('提示：' + data.Msg)
                  }
                }
              }
            })
          }).catch(() => { })
        }
      })
    },
    synRate (index, row, isSyn) {
      if (row && row !== null && typeof (row) !== 'undefined') {
        var msg = ''
        if (isSyn) {
          msg = '从云平台下发同步到线下客户端'
        } else {
          msg = '从线下客户端上传同步到云平台'
        }
        this.$confirm('将客户[' + row.fCustName + ']的费率[' + row.fRateName + ']' + msg + ', 是否继续?', '提示', {
          cancelButtonText: '取消',
          confirmButtonText: '确定',
          type: 'warning'
        }).then(() => {
          this.synRateById({
            fBigRowID: row.fBigRowID,
            fIsSyn: isSyn
          }).then(res => {
            let { status, data } = res
            if (status === 200) {
              if (data.IsOk) {
                this.$message({
                  type: 'success',
                  message: '操作完成'
                })
                this.initData()
              } else {
                this.$message.error(data.Msg)
              }
            }
          })
        }).catch(() => { })
      }
    },
    editRateClient (index, row) {
      this.editOrDetail = 'editBaseInfo'
      if (row && row !== null && typeof (row) !== 'undefined') {
        this.updateRate(row, true, 'edit')
      }
    },
    deleteRateClient (index, row) {
      this.$confirm('删除该记录, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        api.deleteRate({ fBigRowID: row.fBigRowID, fIsSyn: this.rateActiveName === 'synRateList' }).then(res => {
          if (res && res.data) {
            let { status, data } = res
            if (status === 200) {
              if (data.IsOk) {
                this.$message({
                  type: 'success',
                  message: data.Msg
                })
                this.initData()
              } else {
                this.$message.error(data.Msg)
              }
            }
          }
        })
      }).catch(() => {
      })
    },
    changeValue (value) {
    },
    bindQuery () {
      this.initData()
      // let obj = {}
      // obj = this.choiceCusts.find((item) => {
      //   return item.fCustID === this.selCustID
      // })
      // this.custName = obj.unionName
    },
    rateCurrentChange (val) {
      if (val !== null && typeof (val) !== 'undefined') {
        this.currentRow = val
      }
    },
    tableRowClassName ({ row, rowIndex }) {
      if (row.fIsDel === '1') {
        return 'warning-row'
      }
      return ''
    },
    setTableHeight (obj) {
      let clientHeight = obj.getRJPageSize.getRJPageSize()[3] - 25 - 230
      obj.tableHeight = clientHeight
    },
    initData () {
      var isSyn = this.rateActiveName === 'synRateList'
      if (isSyn) {
        this.synRateList = []
      } else {
        this.rateList = []
      }
      this.loading = true
      this.getRateByQuery({
        fCustID: this.selCustID,
        fRateName: this.bindQueryInput.trim(),
        pageSize: this.pageSize,
        pageNo: this.pageNo,
        rateActiveName: this.rateActiveName
      }).then(res => {
        this.loading = false
        if (res && res.data) {
          let { status, data } = res
          if (status === 200) {
            if (data.IsOk) {
              this.total = data.Data.total
              if (isSyn) {
                this.synRateList = data.Data.rows
              } else {
                this.rateList = data.Data.rows
              }
            } else {
              this.$message.error('提示：费率数据加载失败')
            }
          }
        }
      })
    }
  },
  created () {
    this.getCurrentUserPers({ perTypeId: 50000 }).then(res => {
      if (res && res.data) {
        var data = res.data
        if (data.IsOk) {
          if (data.Data) {
            this.is_edit = data.Data.data.is_edit
            this.is_del = data.Data.data.is_del
            this.is_syn = data.Data.data.is_syn
          }
        } else {
          this.$message.error('提示：加载当前用户权限信息失败')
        }
      }
    })
  },
  mounted () {
    let sizethis = this
    window.onresize = () => {
      this.setTableHeight(sizethis)
    }
    this.getCustByGroup().then(res => {
      if (res && res.data) {
        let { status, data } = res
        if (status === 200) {
          if (data.IsOk) {
            let custs = []
            Object.assign(custs, data.Data)
            this.choiceCusts = custs
            this.offlineCusts = custs.filter(r => r.fCustTypeID === '0') // 封闭式客户
          }
        }
      }
    })
    this.initData()
    this.loadRateDDLSource({}).then(res => {
      if (res && res.data) {
        let { status, data } = res
        if (status === 200) {
          if (data.IsOk) {
            Object.assign(this.time, data.Data.time)
            Object.assign(this.rateTemplate, data.Data.rateTemplate)
            Object.assign(this.timeOut, data.Data.timeOut)
            Object.assign(this.crossTimeSec, data.Data.crossTimeSec)
            Object.assign(this.cbo24CalcTime, data.Data.cbo24CalcTime)
            Object.assign(this.freeTimeTypes, data.Data.freeTimeTypes)
            Object.assign(this.cbo24UpAmtTime, data.Data.cbo24UpAmtTime)
            this.defaultValue.rateTemplate_defaultValue = data.Data.rateTemplate_defaultValue
            this.defaultValue.crossTimeSec_defaultValue = data.Data.crossTimeSec_defaultValue
            this.defaultValue.cbo24CalcTime_defaultValue = data.Data.cbo24CalcTime_defaultValue
            this.defaultValue.timeOut_defaultValue = data.Data.timeOut_defaultValue
            this.defaultValue.freeTimeTypes_defaultValue = data.Data.freeTimeTypes_defaultValue
            this.defaultValue.cbo24UpAmtTime_defaultValue = data.Data.cbo24UpAmtTime_defaultValue
          }
        }
      }
    })
  },
  watch: {
    'rateParamInfoObject.chk24Aga002' (newValue, oldValue) {
      if (this.rateParamInfoObject.chk24Aga002) {
        this.rateParamInfoObject.chk24AgaCon002 = false
      }
    },
    'rateParamInfoObject.chk24AgaCon002' (newValue, oldValue) {
      if (this.rateParamInfoObject.chk24AgaCon002) {
        this.rateParamInfoObject.chk24Aga002 = false
      }
    }
  },
  updated () {
    this.setTableHeight(this)
  }
}
</script>
<style>
#rateMain .el-checkbox__input.is-disabled + span.el-checkbox__label {
  color: #606266;
}
#rateMain
  .el-checkbox__input.is-disabled.is-checked
  .el-checkbox__inner::after {
  border-color: #000000;
}
#rateMain .is-disabled .el-input__inner,
#rateMain .is-disabled .el-textarea__inner {
  color: #606266;
}
.rateEditOrDetailDiv .el-dialog__headerbtn {
  top: 10px;
  font-size: 20px;
}
.rateEditOrDetailDiv .el-dialog__title {
  color: white;
}
.rateEditOrDetailDiv .el-dialog__header {
  background-color: #337ab7;
  padding: 10px;
}
.rateEditOrDetailDiv .el-dialog__body {
  padding: 5px;
}
#rateMain .warning-row {
  color: chocolate;
}
</style>
<style scoped>
.text-red {
  color: red;
}
.form-row {
  margin-top: 5px;
}
.el-form-item {
  margin-bottom: 10px;
}
legend {
  display: block;
  width: 100%;
  padding: 0;
  margin-bottom: 10px;
  line-height: inherit;
  color: #333;
  border: 0;
  border-bottom: 1px solid #e5e5e5;
}
fieldset {
  margin: 0 2px;
  border: 0px solid silver;
}
</style>



// WEBPACK FOOTER //
// src/view/rate/rateMain.vue